var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new -265 388.9 64 64"
    },
    viewBox: "-265 388.9 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-214.9,426.7h-36.2c-0.9,0-1.6-0.6-1.6-1.4v-8.6c0-0.8,0.7-1.4,1.6-1.4h36.2c0.9,0,1.6,0.6,1.6,1.4v8.6   C-213.3,426-214,426.7-214.9,426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-214.9,409.4h-36.2c-0.9,0-1.6-0.6-1.6-1.4v-8.6c0-0.9,0.7-1.5,1.6-1.5h36.2c0.9,0,1.6,0.6,1.6,1.4v8.6   C-213.3,408.8-214,409.4-214.9,409.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-214.9,443.9h-36.2c-0.9,0-1.6-0.6-1.6-1.4v-8.6c0-0.8,0.7-1.4,1.6-1.4h36.2c0.9,0,1.6,0.6,1.6,1.4v8.6   C-213.3,443.3-214,443.9-214.9,443.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.4100b998a5857883af5db21a80801ea2.svg";
export { ForwardRef as ReactComponent };